export const ITEM_TYPES = {
  EVENT: 'event',
  ARTICLE: 'article',
  PODCAST: 'podcast',
  WEBINAR: 'webinar'
};

export const ITEM_TYPE_TO_COLOR = {
  [ITEM_TYPES.EVENT]: 'light-pink',
  [ITEM_TYPES.ARTICLE]: 'blue',
  [ITEM_TYPES.PODCAST]: 'salmon',
  [ITEM_TYPES.WEBINAR]: 'teal'
};
